<script>
import { mapGetters } from 'vuex'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
export default {
  name: 'LogModal',
  extends: BaseModal,
  computed: {
    ...mapGetters({
      logEntries: 'getLogEntries'
    })
  }
}
</script>

<template lang="pug">
span
  .modal-header
  .modal-body
    .row.mb-5
      .col-12(v-for="(logEntry, index) in logEntries" :key="index")
        .log-entry {{ logEntry }}

  .modal-footer.fixed
    .row.h-100
      .col-12.col-lg-4.offset-lg-4.h-100.d-flex.align-items-center
        button.btn.btn-primary.btn-block(type="button" v-ea-click="() => {close(true)}") Rozumiem
</template>

<style lang="scss" scoped>
.modal-body {
  background: #eaeaea;
  flex: 1;
  height: calc(100vh - 12vh - 10rem);
}
.log-entry {
  background: white;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 1rem;
  font-size: 1.4rem;
  border-left: 5px solid red;
}
</style>
